export const empresaSedeHomologacionRoutes = (apiBase) => ({
  empresas: `${apiBase}/empresas`,
  empresa: `${apiBase}/empresa`,
  sedes: `${apiBase}/sedes`,
  sede: `${apiBase}/sede`,
  usuarioSede: `${apiBase}/usuario-sede`,
  usuarioSedeAsignar: `${apiBase}/usuario-sede/asignar`,
  usuarioSedeQuitar: `${apiBase}/usuario-sede/quitar`,
  homologacionValores: `${apiBase}/homologacion/valores`,
  homologacionValoresEliminar: `${apiBase}/homologacion/valores/eliminar`,
});
